import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Logo from '../components/Logo';
import PaymentFailureBanner from '../components/PaymentFailureBanner';
import { useAuth } from '../contexts/AuthContext';
import { useSubscription } from '../contexts/SubscriptionContext';
import { subscriptionApi } from '../lib/subscriptionApi';

const navLinks = [
  { to: '/dashboard', label: 'Dashboard', icon: 'home' },
  { to: '/dashboard/create', label: 'Create Request', icon: 'add_circle' },
  { to: '/dashboard/brands', label: 'Brands', icon: 'apartment' },
];

const SidebarLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const { signOut } = useAuth();
  const { subscription } = useSubscription();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await signOut();
    navigate('/login');
  };

  const handleUpdatePayment = async () => {
    if (subscription?.stripe_customer_id) {
      try {
        await subscriptionApi.createPortalSession(subscription.stripe_customer_id);
      } catch (error) {
        console.error('Error creating portal session:', error);
      }
    }
  };

  return (
    <div className="flex min-h-screen bg-gray-50">
      {/* Payment Failure Banner */}
      <PaymentFailureBanner onUpdatePayment={handleUpdatePayment} />
      
      {/* Sidebar */}
      <aside className="w-64 bg-white border-r flex flex-col">
        <Logo />
        <nav className="flex-1 px-4 py-6 space-y-2">
          {navLinks.map(link => (
            <Link
              key={link.to}
              to={link.to}
              className={`flex items-center px-3 py-2 rounded-lg font-medium transition-colors ${
                location.pathname === link.to
                  ? 'bg-gray-100 text-primary'
                  : 'hover:bg-gray-100 text-gray-700'
              }`}
            >
              <span className="material-icons mr-3">{link.icon}</span> {link.label}
            </Link>
          ))}
          <button
            onClick={handleLogout}
            className="w-full mt-4 px-4 py-2 rounded bg-red-100 text-red-600 hover:bg-red-200 font-medium flex items-center justify-center"
          >
            <span className="material-icons mr-2">logout</span> Logout
          </button>
        </nav>
      </aside>
      {/* Main Content */}
      <main className="flex-1 p-8">{children}</main>
    </div>
  );
};

export default SidebarLayout; 